import type { OrderedStepLocal } from "@/services/dexie"

export function getStepRoute(step: OrderedStepLocal, sessionId: string): string {
  switch (step.stepType) {
    case "GDPRConsent":
      return LINKS.consent(sessionId)
    case "Intro":
      return LINKS.intro(sessionId)
    case "VehiclePhoto":
      return LINKS.guideStep(sessionId, step.name)
    case "Damage":
      return LINKS.damageIntro(sessionId)
    case "Claim":
      return LINKS.claim(sessionId)
    case "ExtraEquipment":
      return LINKS.extraEquipmentSelect(sessionId)
    case "DocumentsIntro":
      return LINKS.documentsIntro(sessionId)
    case "DocumentPhoto":
      return LINKS.documentsStep(sessionId, step.name)
    case "VehicleVideo":
      return LINKS.videoStep(sessionId, step.name)
    case "ExtraClientData":
      return LINKS.extraClientData(sessionId)
    case "FinalCheck":
      return LINKS.finalCheck(sessionId)
  }
}

export const LINKS = {
  root: (sessionId: string) => `/${sessionId}`,
  consent: (sessionId: string) => `/${sessionId}/consent`,
  privacyPolicy: (sessionId: string) => `/${sessionId}/privacy-policy`,
  intro: (sessionId: string) => `/${sessionId}/intro`,
  guide: (sessionId: string) => `/${sessionId}/guide`,
  guideStep: (sessionId: string, step: string) => `/${sessionId}/guide/${step}`,
  documents: (sessionId: string) => `/${sessionId}/documents`,
  documentsIntro: (sessionId: string) => `/${sessionId}/documents/intro`,
  documentsStep: (sessionId: string, step: string) => `/${sessionId}/documents/${step}`,
  damage: (sessionId: string) => `/${sessionId}/damage`,
  damageIntro: (sessionId: string) => `/${sessionId}/damage/intro`,
  damageNew: (sessionId: string) => `/${sessionId}/damage/new`,
  damageEdit: (sessionId: string, photoId: string) => `/${sessionId}/damage/edit/${photoId}`,
  damageAddMore: (sessionId: string) => `/${sessionId}/damage/add-more`,
  claim: (sessionId: string) => `/${sessionId}/claim`,
  claimNew: (sessionId: string) => `/${sessionId}/claim/new`,
  claimPhotosSelect: (sessionId: string) => `/${sessionId}/claim/photos/select`,
  claimNewMarker: (sessionId: string, photoId: string) => `/${sessionId}/claim/photos/${photoId}/new-marker`,
  claimMarkerDetails: (sessionId: string, markerId: string) => `/${sessionId}/claim/markers/${markerId}/details`,
  claimOverview: (sessionId: string) => `/${sessionId}/claim/overview`,
  extraEquipment: (sessionId: string) => `/${sessionId}/extra-equipment`,
  extraEquipmentSelect: (sessionId: string) => `/${sessionId}/extra-equipment/select`,
  extraClientData: (sessionId: string) => `/${sessionId}/extra-client-data`,
  finalCheck: (sessionId: string) => `/${sessionId}/final-check`,
  finish: (sessionId: string) => `/${sessionId}/finished`,
  errorIncompatibleDevice: (sessionId: string) => `/${sessionId}/errors/incompatible-device`,
  unsupportedDevice: (sessionId: string) => `/${sessionId}/unsupported-device`,
  debugError: (sessionId: string) => `/${sessionId}/error`,
  testSentry: (sessionId: string) => `/${sessionId}/sentry`,
  permissionsGuide: (sessionId: string) => `/${sessionId}/permissions-guide`,
  permissionsResetGuideAndroid: (sessionId: string) => `/${sessionId}/permissions-reset-guide/android`,
  video: (sessionId: string) => `/${sessionId}/video`,
  videoStep: (sessionId: string, step: string) => `/${sessionId}/video/${step}`,
  canceled: (sessionId: string) => `/${sessionId}/canceled`,
}
